


















import { Vue, Component, Prop } from "@/shared/vuepack";
import CommonTab from "@/employer/components/shared/CommonTab.vue";
import Button from "@/shared/components/ui/Button.vue";
import { PlanSetting } from "@/shared/types";
import { formatPlansDateString } from "@/employer/utilities/myPlansFormatter";

@Component({
  components: { CommonTab }
})
export default class CurrentPlan extends Vue {
  @Prop()
  plans: PlanSetting[];
  formatPlansDateString = formatPlansDateString;

  openLink () {
    // Make this link functional when Products page is created
    // this.$router.push({ name: RouteNames.Products });
  }
}
